module.exports = __webpack_public_path__ + "img/hous-icon.2774d847.svg";